<div class="toolbar-divider"></div>

<style>
	.toolbar-divider {
		@apply w-px h-6 bg-[#002C4D80]/20 mx-1;
	}
</style>
